import { render, staticRenderFns } from "./CardNews.vue?vue&type=template&id=060f3005&scoped=true"
import script from "./CardNews.vue?vue&type=script&lang=js"
export * from "./CardNews.vue?vue&type=script&lang=js"
import style1 from "./CardNews.vue?vue&type=style&index=1&id=060f3005&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "060f3005",
  null
  
)

export default component.exports